import { Platform } from 'react-native';
import { launchImageLibrary } from 'react-native-image-picker';

import type { PickedListingMedia } from '../services/cloudinaryService';

export async function pickListingMedia(remaining: number): Promise<PickedListingMedia | null> {
  if (remaining <= 0) {
    return null;
  }
  if (Platform.OS === 'web') {
    if (typeof document === 'undefined') {
      return null;
    }
    return new Promise(resolve => {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.multiple = false;
      input.onchange = () => {
        const file = input.files?.[0];
        if (!file) {
          resolve(null);
          return;
        }
        resolve({
          uri: URL.createObjectURL(file),
          webFile: file,
        });
      };
      input.click();
    });
  }

  const res = await launchImageLibrary({
    mediaType: 'photo',
    selectionLimit: 1,
    quality: 0.9,
  });
  if (res.didCancel || res.errorCode || !res.assets?.length) {
    return null;
  }
  const a = res.assets[0]!;
  const uri = a.uri;
  if (!uri) {
    return null;
  }
  return {
    uri,
    type: a.type ?? undefined,
    fileName: a.fileName ?? undefined,
  };
}
